import { moduleRouteDictionaryFactory } from '@tundr/routing';

export const brandsRoutesDictionary = moduleRouteDictionaryFactory(
  'brands',
  'brands',
  {
    list: 'list',
    detail: 'detail/:id',
    create: 'create',
    edit: 'edit/:id',
  },
);
